import { Header, About, Services, Contact, Footer } from "../../components";

const HomePage = () => {
    return (
        <>
            <Header />
            <About />
            <Services />
            <Contact />
            <Footer />
        </>
    );
}

export { HomePage };